import React, {useEffect, useState} from "react";
import style from "./style.module.sass";
import Brightness7Icon from '@material-ui/icons/Brightness7';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness3Icon from '@material-ui/icons/Brightness3'
import {useTheme} from "@material-ui/styles";
import {useSelector} from "react-redux";
import {useActions} from "../../../../utils/action-helper";
import {userSetTheme} from "../../../../actions";
import config from "../../../../config";
import { useTranslation } from "react-i18next"

function ThemeHandler() {
  const [isDisabled, setIsDisabled] = useState(false);
  const {theme: {bgColors, borderColors, colors}} = useTheme()
  const {t} = useTranslation()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT);

  // bind actions
  const {actionUserSetTheme} = useActions({
    actionUserSetTheme: userSetTheme,
  })

  const themeOptions = [
    {
      value: config.THEMES_MODES.LIGHT,
      label: 'theme_normal',
      icon: <Brightness7Icon style={{ color: colors.colorProgress120}}/>
    },
    {
      value: config.THEMES_MODES.CONTRAST_LIGHT,
      label: 'theme_high_contrast_light',
      icon: <Brightness4Icon style={{ color: colors.colorIcons }}/>,
    },
    {
      value: config.THEMES_MODES.CONTRAST_DARK,
      label: 'theme_high_contrast_dark',
      icon: <Brightness3Icon style={{color: colors.colorIcons }}/>,
    },
  ]

  useEffect(() => {
    if (isDisabled) {
      setTimeout(() => {
        setIsDisabled(false)
      }, 400)
    }
  }, [isDisabled])

  const setTheme = (newTheme) => {
    if (newTheme === themeState || config.themeSwitchIsAlwaysDisabled || isDisabled) {
      return
    }
    actionUserSetTheme(newTheme)
    setIsDisabled(true)
  }

  return (
    <div
      role="radiogroup"
      aria-label={t('accessibility_header_toggle_theme')}
      className={style.groupCont}
    >
      {themeOptions.map(option => (
        <div key={option.value} tabIndex={config.tabIndexes[`themeButton_${option.label}`]}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              setTheme(option.value)
            }
          }}>
        <label key={option.value} className={style.optionCont}>
          <input
            type="radio"
            name="theme-mode"
            value={option.value}
            checked={themeState === option.value}
            onChange={() => setTheme(option.value)}
            disabled={config.themeSwitchIsAlwaysDisabled || isDisabled}
            className={style.visuallyHiddenInput}
            aria-label={t(option.label)}
          />
          <span
            aria-hidden="true"
            title={t(option.label)}
            style={{
              backgroundColor: bgColors.bgPrimary0,
              outlineColor: themeState === option.value ? borderColors.borderPrimary100 : undefined,
            }}
            className={`${style.mainCont} ${themeState === option.value ? style.selected : ''}`}>
            {option.icon}
          </span>
        </label>
        </div>
      ))}
    </div>
  )
}

export default ThemeHandler
